<template>
  <!--重置密码-->
  <el-dialog title="重置密码" append-to-body :visible.sync="showEditPassword" width="30%" @close="close">
    <el-form ref="ruleForm" :model="account" class="psw-form" :rules="rules" label-width="100px">
      <el-form-item label="旧密码" prop="old_password" required>
        <el-input v-model.trim="account.old_password" required type="password" show-password autocomplete="off" maxlength="20" />
      </el-form-item>
      <el-form-item label="新密码" prop="password" required>
        <el-input v-model.trim="account.password" type="password" show-password autocomplete="off" maxlength="20" minlength="6" />
        <p style="font-size: 12px;text-align: left;margin: 5px 0 0px;line-height: 1.5;letter-spacing: 1px;">必须包含数字,英文,特殊符号[!@#$%^&*(),], 长度8-20位</p>
      </el-form-item>
      <el-form-item label="确认新密码" prop="password_confirmation" required>
        <el-input v-model.trim="account.password_confirmation" type="password" show-password autocomplete="off" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onPost('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { editPsw } from '@/api/user'
import { RES_SUCCESS_CODE } from '@/constances/server'
export default {
  props: {
    accountInfo: {
      type: Object,
      default() {
        return null
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    // var validateOldPass = (rule, value, callback) => {
    //   const reg = /^[0-9A-Za-z]{6,20}$/
    //   if (!reg.test(value)) {
    //     callback(new Error('请输入正确的旧密码'))
    //   } else {
    //     callback()
    //   }
    // }

    var validatePass = (rule, value, callback) => {
      if (!/[0-9]+/.test(value)) {
        return callback(new Error('密码必须包含数字或字母'))
      }
      if (!/[A-Za-z]+/.test(value)) {
        return callback(new Error('密码必须包含数字或字母'))
      }
      if (!/[!@#$%^&*(),]+/.test(value)) {
        return callback(new Error('密码必须包含特殊符号!@#$%^&*(),'))
      }
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else if (value.length > 20) {
        callback(new Error('密码不能超过20位'))
      } else {
        if (this.account.password_confirmation !== '') {
          this.$refs.ruleForm.validateField('password_confirmation')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.account.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      showEditPassword: this.show, // 打开密码修改
      account: { // 当前选中账号信息
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      loading: false,
      formLabelWidth: 180,
      rules: {
        // old_password: [{ validator: validateOldPass, trigger: 'blur' }],
        old_password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        password_confirmation: [{ validator: validatePass2, trigger: 'blur' }]
      }
    }
  },

  watch: {
    show(n) {
      this.showEditPassword = this.show
    },
    accountInfo() {
      this.info = this.accountInfo
      this.showEditPassword = false
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    onPost(name) {
      this.loading = true
      this.$refs[name].validate(valid => {
        if (valid) {
          editPsw(this.account).then(res => {
            if (res.code === RES_SUCCESS_CODE) {
              this.$message({
                type: 'success',
                message: res.message,
                onClose: () => {
                  this.loading = false
                  this.$emit('close')
                }
              })
            }
          })
        } else {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.psw-form {
  width: 80%;
  margin: 0 auto
}
</style>
